import { Component } from '@angular/core';
import { NzFlexDirective } from 'ng-zorro-antd/flex';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';

@Component({
  selector: 'app-footer',
  imports: [NzFlexDirective],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true,
})
export class FooterComponent {}
